import { render, staticRenderFns } from "./cp-card.vue?vue&type=template&id=053d36ba&"
import script from "./cp-card.vue?vue&type=script&lang=js&"
export * from "./cp-card.vue?vue&type=script&lang=js&"
import style0 from "./cp-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports